module.exports = __webpack_public_path__ + "static/media/75a-the-founding-of-prc-06.43e3c7df.png";